import { SearchPagination } from '../BillSearch';

export default class PagingAll implements SearchPagination {
  limit = 4096; // Max elastic search query size
}
